export const loadingSpace = 'loadingSpace'
export const addCargo = 'addCargo'
export const setAxlePressure = 'setAxlePressure'
export const addedCargo = 'addedCargo'
export const noCargoAdded = 'noCargoAdded'
export const removeAll = 'removeAll'
export const setLoadingSpace = 'setLoadingSpace'
export const enterAnyDimensions = 'enterAnyDimensions'
